module.exports = __webpack_public_path__ + "img/emoji-island@3x.becf620.png";